import { defineFieldDisplay } from "../defines";
import Component from "./related-values-select-dropdown-m2o.vue";

export default defineFieldDisplay({
  id: "related-values-select-dropdown-m2o",
  component: Component,
});
